<!-- <div *ngIf="isLoading && (this.router.url != '/angular/' && this.router.url !='/dashboard')" class="busy-indicator" >
    <div class="spinner"></div>
  </div> -->
  <!-- <div *ngIf="isLoading && (this.router.url != '/login' && this.router.url !='/dashboard')" class="busy-indicator" >
    <div class="spinner"></div>
  </div> -->


  <div *ngIf="isLoading && (this.router.url != '/login' && this.router.url !='/dashboard')" class="busy-indicator" >
    <div class="cg-busy-default-wrapper">

      <div class="cg-busy-default-sign">
   
         <div class="cg-busy-default-spinner">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
            <div class="bar4"></div>
            <div class="bar5"></div>
            <div class="bar6"></div>
            <div class="bar7"></div>
            <div class="bar8"></div>
            <div class="bar9"></div>
            <div class="bar10"></div>
            <div class="bar11"></div>
            <div class="bar12"></div>
         </div>
   
         <div class="cg-busy-default-text">Please Wait...</div>
   
      </div>
   
   </div>
  </div>